export default "__VITE_ASSET__2bda752d__"